;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Link from "next/link"
import type { IconType } from "react-icons"
import { FaInstagram, FaLinkedin, FaTiktok, FaYoutube } from "react-icons/fa"

interface FooterTextLink {
  href: string
  label: string
}

interface FooterIconLink extends FooterTextLink {
  icon: IconType
  size: number
}

interface LinkGroupProps {
  links: Array<FooterTextLink | FooterIconLink>
  isIcon?: boolean
}

const leftLinks: FooterTextLink[] = [
  { href: "/about-us", label: "ABOUT US" },
  { href: "/blog", label: "BLOG" },
  { href: "/contact", label: "CONTACT" },
  { href: "/frequently-asked-questions", label: "FAQ" },
  { href: "/policies", label: "POLICIES" },
]

const rightLinks: FooterIconLink[] = [
  {
    href: "https://www.instagram.com/getzestlife",
    icon: FaInstagram,
    size: 24,
    label: "Instagram",
  },
  {
    href: "https://www.tiktok.com/@getzest",
    icon: FaTiktok,
    size: 21,
    label: "TikTok",
  },
  {
    href: "https://www.youtube.com/@getZestLife",
    icon: FaYoutube,
    size: 24,
    label: "YouTube",
  },
  {
    href: "https://www.linkedin.com/company/getzestlife/",
    icon: FaLinkedin,
    size: 24,
    label: "LinkedIn",
  },
]

const LinkGroup = ({ links, isIcon = false }: LinkGroupProps) => (
  <div className="flex justify-between w-full max-w-[250px] mt-1 min-[600px]:max-w-[263px] min-[600px]:mt-0">
    {links.map((link) => {
      const href = link.href
      const label = link.label

      return (
        <Link
          href={href}
          key={label || href}
          className="text-white no-underline hover:underline"
          target={isIcon ? "_blank" : undefined}
          rel="noopener noreferrer"
          aria-label={isIcon ? label : undefined}
        >
          {isIcon && "icon" in link ? <link.icon size={link.size} /> : label}
        </Link>
      )
    })}
  </div>
)

function FooterSimple() {
  return (
    <div className="flex font-bebas bg-black text-white text-[16px] tracking-[.03em] leading-[150%] min-h-[100px] w-full min-[600px]:justify-center min-[600px]:text-[18px] min-[600px]:min-h-[65px]">
      <div className="flex w-full max-w-[1200px] mx-auto px-[20px] justify-between items-center flex-col-reverse py-[16px] min-[600px]:py-0 min-[600px]:px-[30px] min-[600px]:flex-row">
        <LinkGroup links={leftLinks} />
        <LinkGroup links={rightLinks} isIcon={true} />
      </div>
    </div>
  )
}

export default FooterSimple
